import { App } from './app.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';
import { Referrerdomains } from './referrerdomains.class';
import { Fetch } from '../fetch.class';

export class Page {

    constructor() {

        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;

        // --- Option: Spam-Filter
        document.querySelector('#switch_spamfilter').addEventListener('change', event => {
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("use_spamfilter", value);

            // Senden
            new Fetch().post(App.getUrl('form', 'save_usespamfilter'), data)
            .then(response => {

                // Erfolgsmeldung
                new Notification().success(response.msg);
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                new Notification().error(error.message);

                // Switch zurücksetzen
                switchInstance.undo();
            });
        });


        // --- Option: Captcha
        let $switch_captcha = document.querySelector('#switch_captcha');
        if($switch_captcha) {
            document.querySelector('#switch_captcha').addEventListener('change', event => {
                const switchInstance = event.detail.switch;
                const value = switchInstance.isActivated();

                const data = new FormData();
                data.append("form_code", this.form_code);
                data.append("use_captcha", value);

                // Senden
                new Fetch().post(App.getUrl('form', 'save_usecaptcha'), data)
                .then(response => {

                    // Erfolgsmeldung
                    new Notification().success(response.msg);
                })
                .catch(error => {

                    // Fehlermeldung anzeigen
                    new Notification().error(error.message);

                    // Switch zurücksetzen
                    switchInstance.undo();
                });
            });
        }


        // --- freigegebene Domains
        new Referrerdomains('#referrerdomains', true, this.form_code);


        // --- Honeypot

        // Elemente
        this.$btnEditHoneypot = document.querySelector('button.honeypot');
        this.$inputEditHoneypot = document.querySelector('#modal-edit-honeypot input[name=honeypot]');
        this.$displayHoneypot = document.querySelector('#value_honeypot');
        this.$displayHoneypotEmpty = document.querySelector('#value_honeypot_empty');
        this.$formEditHoneypot = document.querySelector('#modal-edit-honeypot form');
        this.$errorboxEditHoneypot = document.querySelector('#modal-edit-honeypot .errorbox');

        // Modal
        this.modalEditHoneypot = new Modal('#modal-edit-honeypot');

        // Modaldialog öffnen
        this.$btnEditHoneypot.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditHoneypot.classList.add('hidden');

            // Modal öffnen
            this.modalEditHoneypot.show();
        });

        // Speicherung
        this.$formEditHoneypot.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("honeypot", this.$inputEditHoneypot.value);

            // Fehler ausblenden
            this.$errorboxEditHoneypot.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('form', 'save_honeypot'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditHoneypot.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                if(this.$inputEditHoneypot.value.trim() == '') {
                    this.$displayHoneypot.classList.add('hidden');
                    this.$displayHoneypotEmpty.classList.remove('hidden');
                }
                else {
                    this.$displayHoneypot.classList.remove('hidden');
                    this.$displayHoneypotEmpty.classList.add('hidden');
                    this.$displayHoneypot.textContent = this.$inputEditHoneypot.value;
                }
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditHoneypot.querySelector('.cont').textContent = error.message;
                this.$errorboxEditHoneypot.classList.remove('hidden');
            });
        });

        // --- Option: Email Validierung
        document.querySelector('#switch_emailvalidation').addEventListener('change', event => {
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("use_emailvalidation", value);

            // Senden
            new Fetch().post(App.getUrl('form', 'save_useemailvalidation'), data)
            .then(response => {

                // Erfolgsmeldung
                new Notification().success(response.msg);
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                new Notification().error(error.message);

                // Switch zurücksetzen
                switchInstance.undo();
            });
        });

        // --- Option: IP-Blacklist
        document.querySelector('#switch_ipblacklist').addEventListener('change', event => {
            const switchInstance = event.detail.switch;
            const value = switchInstance.isActivated();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("use_ipblacklist", value);

            // Senden
            new Fetch().post(App.getUrl('form', 'save_useipblacklist'), data)
            .then(response => {

                // Erfolgsmeldung
                new Notification().success(response.msg);
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                new Notification().error(error.message);

                // Switch zurücksetzen
                switchInstance.undo();
            });
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-spam')) {
        new Page();
    }
});